export default __webpack_public_path__ + "static/media/logo-all-dark.f94441b8.png";